import { Divider, Typography } from '@material-ui/core';
import React, { FunctionComponent } from 'react';
import LabelAndPrice from '../labels/LabelAndPrice';
import VehicleTotalPrice from '../vehicleTotalPrice/VehicleTotalPrice';
import { IFinanceQuote } from '../../../../../../common/model/IFinanceQuote';
import { ICarDetails } from '../../../../../../../../common/model/ICarDetails';
import SummaryFinanceMinimal from './SummaryFinanceMinimal';
import SummaryTradeIn from '../SummaryTradeIn/SummaryTradeIn';
import FirstRegistrationTax from '../firstRegistrationTax/FirstRegistrationTax';
import summaryMinimalStyles from './summaryMinimalClasses';
import Translation from '../../../../../../common/components/translation/Translation';

export interface ISummaryMinimalProps {
  loading?: boolean;
  currency: string;
  totalWithServicePlan: number;
  basePrice: number;
  monthlyPayment: number;
  selectionsPrice: number;
  firstRegistrationTax?: number;
  modelTitle: string;
  variantTitle: string;
  shouldRenderRates: boolean;
  shouldRenderTerm: boolean;
  financeQuote: IFinanceQuote;
  carConfiguration: ICarDetails;
  toggleFinanceCalculatorSpc?: (shouldOpen: boolean) => void;
}

const SummaryMinimal: FunctionComponent<ISummaryMinimalProps> = ({
  currency,
  basePrice,
  monthlyPayment,
  selectionsPrice,
  firstRegistrationTax,
  totalWithServicePlan,
  modelTitle,
  variantTitle,
  loading,
  shouldRenderRates,
  shouldRenderTerm,
  financeQuote,
  carConfiguration,
  toggleFinanceCalculatorSpc,
}) => {
  const styles = summaryMinimalStyles();

  return (
    <>
      <LabelAndPrice
        loading={loading}
        label={
          <>
            <Typography
              component="span"
              className={styles.modelTitlePriceLabel}
              data-test="customise:summary:model_title"
            >
              {modelTitle}
            </Typography>
            &nbsp;
            <Typography component="span" data-test="customise:summary:variant_title">
              {variantTitle}
            </Typography>
          </>
        }
        price={basePrice}
        priceType="basePrice"
        currency={currency}
        labelClassNames={styles.vehicleTitlePriceLabel}
      />
      <LabelAndPrice
        loading={loading}
        label={<Translation id={'spc.customise.options'} />}
        price={selectionsPrice}
        priceType="selections"
        currency={currency}
      />
      {firstRegistrationTax !== null && firstRegistrationTax !== undefined && (
        <FirstRegistrationTax loading={loading} price={firstRegistrationTax} currency={currency} />
      )}
      <Divider />
      <VehicleTotalPrice loading={loading} price={totalWithServicePlan} currency={currency} />
      <SummaryTradeIn />
      <SummaryFinanceMinimal
        loading={loading}
        currency={currency}
        shouldRenderRates={shouldRenderRates}
        shouldRenderTerm={shouldRenderTerm}
        financeQuote={financeQuote}
        monthlyPayment={monthlyPayment}
        carConfiguration={carConfiguration}
        toggleFinanceCalculatorSpc={toggleFinanceCalculatorSpc}
      />
    </>
  );
};

export default SummaryMinimal;
